import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import {
  containerStyle,
  leftBoxStyle,
  titleStyle,
  contestTitleStyle,
  progressContainerStyle,
  progressRowStyle,
  progressLabelStyle,
  linearProgressContainerStyle,
  linearProgressStyle,
} from "./styles";

interface HeaderFinishQuizProps {
  progress?: number;
  correctAnswers?: number;
  totalAnswers?: number;
  isContest?: boolean;
  contestTitle?: string | null;
}

export const HeaderFinishQuiz: React.FC<HeaderFinishQuizProps> = ({
  progress = 20,
  isContest = false,
  contestTitle = null,
}) => {
  const resolvedContestTitle =
    typeof contestTitle === "string" && contestTitle.trim()
      ? contestTitle.trim()
      : null;

  return (
    <Box sx={containerStyle}>
      <Box sx={leftBoxStyle}>
        <Typography sx={titleStyle}>
          {isContest ? "TAP Knowledge Challenge 🏆" : "Test your knowledge 🧠"}
        </Typography>
        {isContest && resolvedContestTitle ? (
          <Typography
            sx={contestTitleStyle}
            title={resolvedContestTitle}
            noWrap
          >
            {resolvedContestTitle}
          </Typography>
        ) : null}
      </Box>
      <Box sx={progressContainerStyle}>
        <Box sx={progressRowStyle}>
          <Typography variant="body2" sx={progressLabelStyle}>
            Progress
          </Typography>
          <Typography variant="body2" sx={progressLabelStyle}>
            {progress}%
          </Typography>
        </Box>
        <Box sx={linearProgressContainerStyle}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={linearProgressStyle}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderFinishQuiz;
